"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserHeader = exports.createError = exports.createURL = exports.createChannel = exports.fetch = void 0;
var fetch_ponyfill_1 = __importDefault(require("fetch-ponyfill"));
var nanoid_1 = require("nanoid");
var fetch = fetch_ponyfill_1.default().fetch;
exports.fetch = fetch;
// + and - are used as delimiters in the uri, ensure they do not appear in the channel itself
var VALID_CHANNEL_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!_';
var generateChannel = nanoid_1.customAlphabet(VALID_CHANNEL_CHARS, 10);
function createChannel(channel) {
    channel = channel !== null && channel !== void 0 ? channel : generateChannel();
    if (channel.length < 6) {
        throw new Error('Please use a channel id with more entropy');
    }
    for (var _i = 0, channel_1 = channel; _i < channel_1.length; _i++) {
        var char = channel_1[_i];
        if (VALID_CHANNEL_CHARS.indexOf(char) < 0) {
            throw new Error('Channel id contains invalid characters');
        }
    }
    return channel;
}
exports.createChannel = createChannel;
function createURL(host, sdkVersion, channel, id) {
    if (channel) {
        return id
            ? id.startsWith('@')
                ? "exp://" + host + "/" + id + "+" + channel
                : "exp://" + host + "/@snack/" + id + "+" + channel
            : "exp://" + host + "/@snack/sdk." + sdkVersion + "-" + channel;
    }
    else if (id) {
        return "exp://" + host + "/" + (id.match(/.*\/.*/) ? id : "@snack/" + id);
    }
    else {
        return '';
    }
}
exports.createURL = createURL;
function createError(config) {
    var error = new Error(config.message);
    if (config.name)
        error.name = config.name;
    if (config.fileName)
        error.fileName = config.fileName;
    if (config.lineNumber)
        error.lineNumber = config.lineNumber;
    if (config.columnNumber)
        error.columnNumber = config.columnNumber;
    if (config.stack)
        error.stack = config.stack;
    return error;
}
exports.createError = createError;
function createUserHeader(user) {
    if (user === null || user === void 0 ? void 0 : user.sessionSecret) {
        return { 'Expo-Session': user.sessionSecret };
    }
    if (user === null || user === void 0 ? void 0 : user.accessToken) {
        return { Authorization: "Bearer " + user.accessToken };
    }
    return {};
}
exports.createUserHeader = createUserHeader;
//# sourceMappingURL=utils.js.map